<template>
    <v-card outlined class="mt-3">
        <v-list-item class="title__stys">
            <v-list-item-content class="title__sty white--text">{{$t('ProductCouponStar_title1')}}</v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <div class="px-4 py-5 area__sty">
            <div class="my-n1 area__radio__sty">
                <p class="subsubtitle__sty alert__sty">※{{$t('ProductCouponStar_text9')}}</p>
                <v-radio-group v-model="CouponStarradioGroup" @change="onCouponStarTypeChange($event)">
                    <v-radio
                        v-for="(item, idx) in CouponStarType"
                        :key="'A' + idx"
                        :label="item.name"
                        :value="item.value"
                        class="radio__sty"
                    ></v-radio>
                </v-radio-group>
                <!-- 折價券折抵 -->
                <div v-show="CouponStarradioGroup === 1">
                    <v-row no-gutters>
                        <v-col cols="9" class="pr-2">
                            <v-text-field
                                :placeholder="$t('ProductCouponStar_input1')"
                                outlined
                                dense
                                v-model="coupon_txt"
                                class="input__sty"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="3" class="btn__sty">
                            <v-btn
                                v-if="show_send"
                                depressed
                                class="white--text"
                                @click="usesCouponStarPoint()"
                            >
                                {{$t('ProductCouponStar_button1')}}
                            </v-btn>
                            <v-btn
                                v-else
                                depressed
                                class="white--text"
                                @click="usesCouponStarPoint()"
                            >
                                {{$t('ProductCouponStar_button2')}}
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
                <!-- 星幣折抵 -->
                <div v-show="CouponStarradioGroup === 2" class="subsub__area__sty">
                    <span class="subsubtitle__sty">{{$t('ProductCouponStar_text1_1')}}{{getusercheerpoint}}{{$t('ProductCouponStar_text1_2')}}{{getusercheerpoint}} ({{$t('ProductCouponStar_text1_3')}}{{ this.$store.state.shippingprice.shippingpriceData.cheerpointlimit }}{{$t('ProductCouponStar_text1_4')}})</span>
                    <v-row no-gutters class="mt-3">
                        <v-col cols="9" class="pr-2">
                            <v-text-field
                                :placeholder="$t('ProductCouponStar_input2')"
                                outlined
                                dense
                                v-model="use_star_point"
                                type="number"
                                class="input__sty"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="3" class="btn__sty">
                            <v-btn
                                v-if="show_send"
                                depressed
                                class="white--text"
                                @click="usesCouponStarPoint()"
                            >
                                {{$t('ProductCouponStar_button1')}}
                            </v-btn>
                            <v-btn
                                v-else
                                depressed
                                class="white--text"
                                @click="usesCouponStarPoint()"
                            >
                                {{$t('ProductCouponStar_button2')}}
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
                <!-- 購物金折抵 -->
                <div v-show="CouponStarradioGroup === 3" class="subsub__area__sty">
                    <div class="mb-3">
                        <v-row no-gutters v-if="!showarea.moneycoupon">
                            <v-col cols="9" class="pr-2">
                                <v-text-field
                                    :placeholder="$t('ProductCouponStar_input3')"
                                    outlined
                                    dense
                                    v-model="use_shop_money"
                                    type="number"
                                    class="input__sty"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3" class="btn__sty">
                                <v-btn
                                    v-if="show_send"
                                    depressed
                                    class="white--text"
                                    @click="usesCouponStarPoint()"
                                >
                                    {{$t('ProductCouponStar_button1')}}
                                </v-btn>
                                <v-btn
                                    v-else
                                    depressed
                                    class="white--text"
                                    @click="usesCouponStarPoint()"
                                >
                                    {{$t('ProductCouponStar_button2')}}
                                </v-btn>
                            </v-col>
                            <div class="bind__btn__sty">
                                <v-btn
                                    small
                                    depressed
                                    class="white--text use__btn__sty"
                                    v-show="!showarea.moneycoupon"
                                    @click="showMoneyCoupon"
                                >
                                    {{$t('ProductCouponStar_button3')}}
                                </v-btn>
                            </div>
                        </v-row>
                        <v-row no-gutters v-else>
                            <v-col cols="9" class="pr-2">
                                <v-text-field
                                    :placeholder="$t('ProductCouponStar_input4')"
                                    outlined
                                    dense
                                    v-model="money_coupon"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="3" class="btn__sty">
                                <v-btn
                                    v-if="show_send"
                                    depressed
                                    class="white--text"
                                    @click="usesMoneyCoupon()"
                                >
                                    {{$t('ProductCouponStar_button1')}}
                                </v-btn>
                                <v-btn
                                    v-else
                                    depressed
                                    class="white--text"
                                    @click="usesMoneyCoupon()"
                                >
                                    {{$t('ProductCouponStar_button2')}}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </div>
            <v-divider class="mb-4 white"></v-divider>
            <div class="priceinfo__sty">
                <p class="text-left">
                    {{$t('ProductCouponStar_text3')}}
                    <span class="float-right">NT${{ this.$store.state.shippingprice.shippingpriceData.price }}</span>
                </p>
                <p class="text-left">
                    {{$t('ProductCouponStar_text4')}}
                    <span class="float-right">NT${{ this.$store.state.shippingprice.shippingpriceData.totalshippingfee }}</span>
                </p>
                <p class="text-left">
                    {{$t('ProductCouponStar_text5')}}
                    <span class="float-right">-NT${{ this.$store.state.couponpoint.couponprice }}</span>
                </p>
                <p class="text-left">
                    {{$t('ProductCouponStar_text6')}}
                    <span class="float-right">-NT${{ this.$store.state.couponpoint.starprice }}</span>
                </p>
                <p class="text-left">
                    {{$t('ProductCouponStar_text7')}}
                    <span class="float-right">-NT${{ this.$store.state.couponpoint.shopprice }}</span>
                </p>
                <p class="mx-n4 px-4 py-2 text-left white">
                    {{$t('ProductCouponStar_text8')}}
                    <span class="float-right">NT${{ this.$store.state.shippingprice.shippingpriceData.totalshippingfee + this.$store.state.shippingprice.shippingpriceData.price - this.$store.state.couponpoint.starprice - this.$store.state.couponpoint.couponprice -this.$store.state.couponpoint.shopprice }}</span>
                    <!-- <span class="float-right">NT${{ this.$store.state.shippingprice.shippingpriceData.price - this.$store.state.couponpoint.starprice - this.$store.state.couponpoint.couponprice -this.$store.state.couponpoint.shopprice }}</span> -->
                </p>
            </div>
        </div>
    </v-card>
</template>

<script>
    export default {
        name: 'ProductCouponStar',
        props: ['getusercheerpoint'],

        data: function () {
            return {
                token: sessionStorage.getItem('accessToken'),
                user_uuid: sessionStorage.getItem('user_uuid'),
                // 剩餘購物金
                balance: 0,
                // 使用序號
                coupon_txt: '',
                // 使用星幣數目
                use_star_point: 0,
                // 使用購物金數目
                use_shop_money: 0,
                // 綁定購物金
                money_coupon: '',
                show_send: true,
                // 選擇優惠
                CouponStarradioGroup: 0,
                // 0: 未使用優惠 1:使用序號 2:使用星幣 3:使用購物金
                CouponStarType: [
                    { name: this.$t('ProductCouponStar_input5'), value: 0 },
                    { name: this.$t('ProductCouponStar_input6'), value: 3 },
                    { name: this.$t('ProductCouponStar_input7'), value: 1 },
                    { name: this.$t('ProductCouponStar_input8'), value: 2},
                ],
                // 購物金儲值/使用顯示區塊
                showarea: {
                    moneycoupon: false
                }
            }
        },
        computed: {
        },
        methods: {
            // 使用優惠, 0: 未使用優惠 1:使用序號 2:使用星幣 3:使用購物金
            usesCouponStarPoint() {
                if (this.CouponStarradioGroup === 1) {
                    if (this.coupon_txt !== '') {
                        this.$store.state.couponpoint.couponinput = this.coupon_txt;
                        this.axios({
                            method: 'post',
                            url: `https://${process.env.VUE_APP_API}.cheerlife.io/cart/v1/productions/cart-price`,
                            headers: {
                                Authorization: `Bearer ${this.token}`
                            },
                            data: {
                                user_uuid: this.user_uuid,
                                productions: this.$store.state.putcartlist.putcartData,
                                discount_type: this.CouponStarradioGroup,
                                coupon: this.coupon_txt,
                                use_cheer_point: parseInt(this.use_star_point),
                                use_shop_money: parseInt(this.use_shop_money)
                            },
                        })
                            .then((response) => {
                                this.$store.state.couponpoint.couponprice = response.data.coupon_discount;
                                this.$store.state.couponpoint.starprice = response.data.point_discount;
                                this.$store.state.couponpoint.shopprice = response.data.shopmoney_discount;
                                this.balance = response.data.balance;
                                // 重新計算免運門檻

                                this.show_send = false;
                            })
                            .catch((error) => {
                                // 折價券清除
                                this.coupon_txt = '';
                                this.$store.state.couponpoint.couponprice = 0;
                                this.$store.state.couponpoint.couponinput = '';
                                // 有店家商品未達免運門檻
                                if (error.response.data.error_store !== '') {
                                    let error_store = "";
                                    for (let i = 0; i < this.$store.state.getcartlist.getcartData.length; i++) {
                                        for (let j = 1; j < this.$store.state.getcartlist.getcartData[i].length; j++) {
                                            if (this.$store.state.getcartlist.getcartData[i][j][1].store_uuid === error.response.data.error_store) {
                                                error_store = this.$store.state.getcartlist.getcartData[i][0];
                                            }
                                        }
                                    }
                                    alert(`${error.response.data.message}: ${error_store}`);
                                } else if (error.response.data.message === 'token過期') {
                                    sessionStorage.setItem('accessToken', '');
                                    sessionStorage.setItem('user_uuid', '');
                                    document.cookie = 'accessToken' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                                    document.cookie = 'user_uuid' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                                    this.$router.push('/');
                                    alert(error.response.data.message);
                                } else {
                                    alert(error.response.data.message);
                                }
                            });
                    } else {
                        alert('未輸入折價序號');
                        // 折價券清除
                        this.coupon_txt = '';
                        this.$store.state.couponpoint.couponprice = 0;
                        this.$store.state.couponpoint.couponinput = '';
                    }
                } else if (this.CouponStarradioGroup === 2) {
                    if (this.use_star_point > 0 && this.use_star_point <= this.$store.state.shippingprice.shippingpriceData.cheerpointlimit) {
                        this.axios({
                            method: 'post',
                            url: `https://${process.env.VUE_APP_API}.cheerlife.io/cart/v1/productions/cart-price`,
                            headers: {
                                Authorization: `Bearer ${this.token}`
                            },
                            data: {
                                user_uuid: this.user_uuid,
                                productions: this.$store.state.putcartlist.putcartData,
                                discount_type: this.CouponStarradioGroup,
                                coupon: this.coupon_txt,
                                use_cheer_point: parseInt(this.use_star_point),
                                use_shop_money: parseInt(this.use_shop_money)
                            },
                        })
                            .then((response) => {
                                this.$store.state.couponpoint.couponprice = response.data.coupon_discount;
                                this.$store.state.couponpoint.starprice = response.data.point_discount;
                                this.$store.state.couponpoint.shopprice = response.data.shopmoney_discount;
                                this.balance = response.data.balance;
                                // 重新計算免運門檻

                                this.show_send = false;
                            })
                            .catch((error) => {
                                // 星幣清除
                                this.use_star_point = 0;
                                this.$store.state.couponpoint.starprice = 0;
                                // 有店家商品未達免運門檻
                                if (error.response.data.error_store !== '') {
                                    let error_store = "";
                                    for (let i = 0; i < this.$store.state.getcartlist.getcartData.length; i++) {
                                        for (let j = 1; j < this.$store.state.getcartlist.getcartData[i].length; j++) {
                                            if (this.$store.state.getcartlist.getcartData[i][j][1].store_uuid === error.response.data.error_store) {
                                                error_store = this.$store.state.getcartlist.getcartData[i][0];
                                            }
                                        }
                                    }
                                    alert(`${error.response.data.message}: ${error_store}`);
                                } else if (error.response.data.message === 'token過期') {
                                    sessionStorage.setItem('accessToken', '');
                                    sessionStorage.setItem('user_uuid', '');
                                    document.cookie = 'accessToken' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                                    document.cookie = 'user_uuid' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                                    this.$router.push('/');
                                    alert(error.response.data.message);
                                } else {
                                    alert(error.response.data.message);
                                }
                            });
                    } else if (this.use_star_point > this.$store.state.shippingprice.shippingpriceData.cheerpointlimit) {
                        alert('星幣不可超過折扣上限');
                        // 星幣清除
                        this.use_star_point = 0;
                        this.$store.state.couponpoint.starprice = 0;
                    } else {
                        alert('未輸入星幣');
                        // 星幣清除
                        this.use_star_point = 0;
                        this.$store.state.couponpoint.starprice = 0;
                    }
                } else {
                    if (this.use_shop_money > 0) {
                        // 購物金可折抵運費(免運門檻計算是後端回的)
                        const price = this.$store.state.shippingprice.shippingpriceData.price+this.$store.state.shippingprice.shippingpriceData.totalshippingfee;
                        if (parseInt(this.use_shop_money) <= price) {
                            this.axios({
                                method: 'post',
                                url: `https://${process.env.VUE_APP_API}.cheerlife.io/cart/v1/productions/cart-price`,
                                headers: {
                                    Authorization: `Bearer ${this.token}`
                                },
                                data: {
                                    user_uuid: this.user_uuid,
                                    productions: this.$store.state.putcartlist.putcartData,
                                    discount_type: this.CouponStarradioGroup,
                                    coupon: this.coupon_txt,
                                    use_cheer_point: parseInt(this.use_star_point),
                                    use_shop_money: parseInt(this.use_shop_money)
                                },
                            })
                                .then((response) => {
                                    this.$store.state.couponpoint.couponprice = response.data.coupon_discount;
                                    this.$store.state.couponpoint.starprice = response.data.point_discount;
                                    this.$store.state.couponpoint.shopprice = response.data.shopmoney_discount;
                                    this.balance = response.data.balance;
                                    // 重新計算免運門檻

                                    this.show_send = false;
                                })
                                .catch((error) => {
                                    // 購物金清除
                                    this.use_shop_money = 0;
                                    this.$store.state.couponpoint.shopprice = 0;
                                    // 有店家商品未達免運門檻
                                    if (error.response.data.error_store !== '') {
                                        let error_store = "";
                                        for (let i = 0; i < this.$store.state.getcartlist.getcartData.length; i++) {
                                            for (let j = 1; j < this.$store.state.getcartlist.getcartData[i].length; j++) {
                                                if (this.$store.state.getcartlist.getcartData[i][j][1].store_uuid === error.response.data.error_store) {
                                                    error_store = this.$store.state.getcartlist.getcartData[i][0];
                                                }
                                            }
                                        }
                                        alert(`${error.response.data.message}: ${error_store}`);
                                    } else if (error.response.data.message === 'token過期') {
                                        sessionStorage.setItem('accessToken', '');
                                        sessionStorage.setItem('user_uuid', '');
                                        document.cookie = 'accessToken' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                                        document.cookie = 'user_uuid' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                                        this.$router.push('/');
                                        alert(error.response.data.message);
                                    } else {
                                        alert(error.response.data.message);
                                    }
                                });
                        } else {
                            alert('超過可用購物金限制');
                            // 購物金清除
                            this.use_shop_money = 0;
                            this.$store.state.couponpoint.shopprice = 0;
                        }
                    } else {
                        alert('未輸入購物金');
                        // 購物金清除
                        this.use_shop_money = 0;
                        this.$store.state.couponpoint.shopprice = 0;
                    }
                }
            },
            // 切換優惠
            onCouponStarTypeChange(e) {
                // 切換折扣
                this.$store.state.couponpoint.usetype = this.CouponStarradioGroup;
                // 還原價格
                this.$store.state.shippingprice.shippingpriceData.price = this.$store.state.shippingprice.shippingpriceData.oldprice;
                // 0: 未使用優惠 1:使用序號 2:使用星幣 3:使用購物金
                if (e === 1) {
                    // 星幣清除
                    this.use_star_point = 0;
                    this.$store.state.couponpoint.starprice = 0;
                    // 購物金清除
                    this.use_shop_money = 0;
                    this.$store.state.couponpoint.shopprice = 0;
                } else if (e === 2) {
                    // 折價券清除
                    this.coupon_txt = '';
                    this.$store.state.couponpoint.couponprice = 0;
                    this.$store.state.couponpoint.couponinput = '';
                    // 購物金清除
                    this.use_shop_money = 0;
                    this.$store.state.couponpoint.shopprice = 0;
                } else if (e === 3) {
                    // 星幣清除
                    this.use_star_point = 0;
                    this.$store.state.couponpoint.starprice = 0;
                    // 折價券清除
                    this.coupon_txt = '';
                    this.$store.state.couponpoint.couponprice = 0;
                    this.$store.state.couponpoint.couponinput = '';
                    // 重新取可使用購物金
                    this.getBalance();
                } else {
                    // 星幣清除
                    this.use_star_point = 0;
                    this.$store.state.couponpoint.starprice = 0;
                    // 折價券清除
                    this.coupon_txt = '';
                    this.$store.state.couponpoint.couponprice = 0;
                    this.$store.state.couponpoint.couponinput = '';
                    // 購物金清除
                    this.use_shop_money = 0;
                    this.$store.state.couponpoint.shopprice = 0;
                }
            },
            // 取得購物金
            getBalance() {
                this.axios({
                    method: 'post',
                    url: `https://${process.env.VUE_APP_API}.cheerlife.io/cart/v1/users/get-shopmoney`,
                    headers: {
                        Authorization: `Bearer ${this.token}`
                    },
                    data: {
                        user_uuid: this.user_uuid,
                    },
                })
                    .then((response) => {
                        this.balance = response.data.balance;
                        this.CouponStarType[1].name = `${this.$t('ProductCouponStar_input6')}NT$${this.balance}`;
                    })
                    .catch((error) => {
                        alert(error.response.data.message);
                        if (error.response.data.message === 'token過期') {
                            sessionStorage.setItem('accessToken', '');
                            sessionStorage.setItem('user_uuid', '');
                            document.cookie = 'accessToken' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                            document.cookie = 'user_uuid' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                            this.$router.push('/');
                        }
                    });
            },
            // 綁定購物金區塊
            showMoneyCoupon() {
                this.showarea.moneycoupon = true;
            },
            // 綁定購物金
            usesMoneyCoupon() {
                if (this.money_coupon === '') {
                    alert('未輸入購物金序號');
                } else {
                    this.axios({
                        method: 'post',
                        url: `https://${process.env.VUE_APP_API}.cheerlife.io/cart/v1/users/import-shopmoney`,
                        headers: {
                            Authorization: `Bearer ${this.token}`
                        },
                        data: {
                            user_uuid: this.user_uuid,
                            coupon: this.money_coupon
                        },
                    })
                        .then((response) => {
                            this.balance = response.data.balance;
                            this.money_coupon = '';
                            alert(response.data.message);
                        })
                        .catch((error) => {
                            alert(error.response.data.message);
                            if (error.response.data.message === 'token過期') {
                                sessionStorage.setItem('accessToken', '');
                                sessionStorage.setItem('user_uuid', '');
                                document.cookie = 'accessToken' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                                document.cookie = 'user_uuid' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                                this.$router.push('/');
                            }
                        });
                }
                this.showarea.moneycoupon = false;
            },
        },
        mounted() {
            this.getBalance();
        }
    }
</script>

<style lang="sass">
    .radio__sty .v-label
        color: #352D40
        font-weight: bold
        font-size: 13px
        line-height: 17px
        letter-spacing: 0.1em
</style>
<style scoped lang="sass">
    .theme--light.v-card.v-sheet--outlined
        border: none
    .area__sty
        background-color: #F2F2F2
    .title__stys
        background-color: #BDBDBD
    .title__sty
        font-weight: bold
        font-size: 15px
        letter-spacing: 0.1em
    .btn__sty button
        background-color: #352D40 !important
        font-weight: bold
        font-size: 13px
        letter-spacing: 0.1em
    .priceinfo__sty p
        color: #352D40
        font-weight: bold
        font-size: 13px
        letter-spacing: 0.1em
    .subtitle__sty
        color: #352D40
        font-weight: bold
        font-size: 13px
        letter-spacing: 0.1em
    .subsub__area__sty
        line-height: 17px
    .subsubtitle__sty, .alert__sty
        color: #352D40
        font-weight: bold
        font-size: 13px
        letter-spacing: 0em
    .alert__sty
        color: #b80000
    .area__radio__sty
        margin-top: 0px
        padding-top: 0px
    .area__radio__sty .v-input--selection-controls
        margin-top: 0px
        padding-top: 0px
    .use__btn__sty
        background: #352D40 !important
    .bind__btn__sty
        display: inline-block
        float: right
    @media only screen and (max-width: 345px)
        .bind__btn__sty
            display: block
</style>
